<template>
    <div>
        <div v-if="currentTerms" class="terms panel-body">
            <div class="form-group">
                <label>Week</label>
                <select @change="getContent" class="form-control" v-model="currentWeek">
                    <option v-for="i in 16" :value="i">{{i}}</option>
                </select>
            </div>
            <div v-for="term in currentTerms">
                <h4>
                    {{term.name}}                  
                </h4>                
                <ul>                    
                    <li v-if="term.instances.length === 0">No content this week</li>
                    <li v-for="instance in term.instances" class="clearfix">

                        <h5 @click.prevent="selectedTerm = term.id; selectedInstance === instance.id ? selectedInstance = null : selectedInstance = instance.id" class="instance-name">
                            <span @click="selectedTab = 'description'" :title="'Course ID: ' + instance.associated.id">
                                <i class="fa fa-caret-down" v-if="selectedInstance === instance.id"></i>
                                <i v-else class="fa fa-caret-right"></i>
                                {{instance.associated.name}}                                
                            </span>
                            <img v-if="instance.video.assignment" @click.prevent="selectedTab='assignment'" src="./../../assets/img/assignment-icon.png">
                            <img v-if="instance.video.exercise" @click.prevent="selectedTab='exercise'" src="./../../assets/img/excercise-icon.png">  

                        </h5>
                        <div class="video" v-if="selectedInstance === instance.id">
                            <div class="" v-if="instance.video">
                                <div class="panel col-xs-12 col-md-8 video-player-wrapper">
                                    <div class="sku">
                                        {{instance.video.sku}}
                                    </div>
                                    <div class="panel-heading">
                                        <h2>{{instance.video.title}} &mdash; Week {{instance.video.week}}</h2>
                                    </div>
                                    <div class="panel-body">                                        
                                        <poly-video 
                                            ref="videoPlayer" 
                                            :key="selectedChapter.id" 
                                            :sources="[ videoPlayerUrl ]" 
                                            :vjsOptions="videoPlayerVjsOptions" 
                                            :persistPlaybackSpeed="true" 
                                            :persistPlaybackQuality="true" 
                                            @ready="getAnnotations($event), getMarkers($event)" 
                                            @timeupdate="onPlayerTimeupdate($event)" v-if="selectedChapter">
                                        </poly-video>
                                        <img v-else src="./../../assets/img/video-admin-placeholder.png" alt="Video Player" class="video-player-placeholder">
                                        <div class="tabs clearfix">
                                            <ul>
                                                <li v-bind:class="{'active': selectedTab==='description'}" @click="selectedTab = 'description'">
                                                    Description
                                                </li>
                                                <li v-bind:class="{'active': selectedTab==='exercise'}" @click="selectedTab = 'exercise'">
                                                    Exercise
                                                </li>
                                                <li v-bind:class="{'active': selectedTab==='assignment'}" @click="selectedTab = 'assignment'">
                                                    Assignment
                                                </li>
                                                <li v-bind:class="{'active': selectedTab==='comments'}" @click="selectedTab = 'comments'">
                                                    Comments
                                                </li>
                                                <li v-bind:class="{'active': selectedTab==='resources'}" @click="selectedTab = 'resources'">
                                                    Resources
                                                </li>
                                                <li v-bind:class="{'active': selectedTab==='transcript'}" @click="selectedTab = 'transcript'">Live Transcript</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="panel" v-show="selectedTab==='description'">
                                        <div class="panel-heading">
                                            <h2>Lesson Description &#38; Files</h2>
                                        </div>
                                        <div class="panel-body">
                                            <h4>Lesson Description:</h4>
                                            
                                            <div v-html="instance.video.description"></div>
                                            <div v-if="requires(instance.video, 'files')">
                                                <h4>Lesson Files:</h4>                                                
                                                <p v-if="instance.video && instance.video.lesson_files && instance.video.lesson_files.length === 0">No files for this lesson</p>
                                                <table v-if="instance.video && instance.video.lesson_files" class="assignment-files table table-striped">
                                                    <tbody>
                                                        <tr v-for="(file, index) in instance.video.lesson_files" class="list-group-item">
                                                            <td><a :href="file.url" _target="blank">{{file.url | filenameFromUrl}}</a></td>                                                            
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="panel" v-if="selectedTab==='assignment'">
                                        <div class="panel-heading assignments">
                                            <h2><img src="../../assets/img/assignment-icon.png">Assignments</h2>
                                        </div>
                                        <div class="panel-body">
                                            <div v-if="instance.video.assignment">
                                                <form>
                                                    <div class="form-group">
                                                        <b>Available: </b>
                                                        {{instance.video.assignment.availableDate | shortDate}}
                                                    </div>
                                                    <div class="form-group">
                                                        <b>Due: </b>
                                                        {{instance.video.assignment.dueDate | shortDate}}
                                                    </div>
                                                    <div class="form-group">
                                                        <h5>Final Project <input type="checkbox" v-model="instance.video.assignment.isFinalProject" readonly></h5>
                                                    </div>
                                                    <div class="form-group">
                                                        <h5>Name</h5>
                                                        <input class="form-control" type="text" v-model="instance.video.assignment.name" readonly>
                                                    </div>
                                                    <div class="form-group">
                                                        <h5>Difficulty Level</h5>
                                                        <input type="number" class="form-control" v-model="instance.video.assignment.difficulty" readonly>
                                                    </div>
                                                    <div class="form-group">
                                                        <h5>Points</h5>
                                                        <input class="form-control" type="number" v-model="instance.video.assignment.points" readonly>
                                                    </div>
                                                    <div class="form-group">
                                                        <h5>Description</h5>
                                                        <div v-html="instance.video.assignment.description"></div>
                                                    </div>
                                                    <div class="form-group">
                                                        <h5>Assignment Image</h5>
                                                        <img :src="instance.video.assignment.image">
                                                    </div>
                                                    <div class="form-group">
                                                    </div>
                                                    <h5>Files</h5>
                                                    <table class="assignment-files table table-striped">
                                                        <tbody>
                                                            <tr v-for="(file, index) in instance.video.assignment.files" class="list-group-item">
                                                                <td><a :href="file" _target="blank">{{file | filenameFromUrl}}</a></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <table class="assignment-files table table-striped ">
                                                        <tbody>
                                                            <tr v-for="(file, index) in instance.video.assignment.watermarkedFiles" class="list-group-item">
                                                                <td>
                                                                    <a @click.prevent="downloadFile(file, 'assignment', instance.video.assignment.id)" href="#">{{file | filenameFromUrl}}</a>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </form>
                                            </div>
                                            <div v-else>
                                                <p>No assignment for this lesson.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="panel exercise" v-if="selectedTab==='exercise'">
                                        <div class="panel-heading">
                                            <h2>Exercise</h2>
                                        </div>
                                        <div class="panel-body">
                                            <div v-if="instance.video.exercise">
                                                <div>
                                                    <div class="form-group">
                                                        <h5>Name</h5>
                                                        <input v-model="instance.video.exercise.title" class="form-control">
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Due Date</label>
                                                        <br>
                                                        {{instance.video.exercise.dueDate | shortDate}}
                                                    </div>
                                                    <div class="form-group">
                                                        <h5>Description:</h5>
                                                        <div v-html="instance.video.exercise.description"></div>
                                                    </div>
                                                    <div class="form-group">
                                                        <h5>Exercise Image</h5>
                                                        <img v-if="instance.video.exercise.image" :src="instance.video.exercise.image">
                                                    </div>
                                                    <div class="form-group">
                                                        <h5>Files</h5>
                                                        <table class="assignment-files table table-striped ">
                                                            <tbody>
                                                                <tr v-for="(file, index) in instance.video.exercise.files" class="list-group-item">
                                                                    <td><a :href="file" _target="blank">{{file | filenameFromUrl}}</a></td>
                                                                </tr>
                                                                <tr v-for="(file, index) in instance.video.exercise.watermarkedFiles" class="list-group-item">
                                                                    <td>
                                                                        <a @click.prevent="downloadFile(file, 'exercise', instance.video.exercise.id)" href="#">{{file | filenameFromUrl}}</a>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <p>No exercise for this lesson</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="panel" v-if="selectedTab==='comments'">
                                        <div class="panel-heading">
                                            <h2>Comments</h2>
                                        </div>
                                        <div class="panel-body">
                                            <ul class="comments" v-if="comments">
                                                <li v-for="comment in comments">
                                                    <div class="row top-level">
                                                        <div class="col-xs-2">
                                                            <img v-if="comment.user.avatar" v-bind:src="comment.user.avatar">
                                                        </div>
                                                        <div class="col-xs-7">
                                                            <p class="author">
                                                                {{comment.user.firstName}} {{comment.user.lastName}} at <span @click="jumpToTime(comment.time)">{{comment.time | minutesAndSeconds}}</span>
                                                            </p>
                                                            <div v-html="comment.text"></div>
                                                        </div>
                                                        <div class="col-xs-3">
                                                            <div>{{comment.createdAt | timeSince}} ago</div>
                                                            <div>
                                                                <button class="btn btn-xs reply-button" @click.prevent="showReplyForm = comment.id">Reply</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <ul class="replies" v-if="comment.children.length > 0">
                                                        <li v-for="child in comment.children">
                                                            <div class="row">
                                                                <div class="col-xs-2">
                                                                    <img v-if="child.user.avatar" v-bind:src="child.user.avatar">
                                                                </div>
                                                                <div class="col-xs-7">
                                                                    <p class="author">
                                                                        {{child.user.firstName}} {{child.user.lastName}} at <span @click="jumpToTime(comment.time)">{{comment.time | minutesAndSeconds}}</span>
                                                                    </p>
                                                                    <div v-html="child.text"></div>
                                                                    </p>
                                                                </div>
                                                                <div class="col-xs-3">
                                                                    <div>{{comment.createdAt | timeSince}} ago</div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                    <form v-if="showReplyForm===comment.id" @submit.prevent="addComment(instance, comment.id, comment.user)">
                                                        <div class="form-group">
                                                            <vue-html5-editor @change="updateCommentReply($event, comment.id)" :content="content" :height="200"></vue-html5-editor>
                                                        </div>
                                                        <button type="submit" class="btn btn-xs reply-button">Submit Comment Reply</button>
                                                    </form>
                                                </li>
                                            </ul>
                                            <form @submit.prevent="addComment(instance)">
                                                <div class="form-group">
                                                    <label>Add Timeline Comment:<i class="clippie fa fa-info-circle" v-tooltip="'Add and reply to comments directly on the timeline. Great for asking and answering questions specific to a point in time. Set your time marker to a place and add a comment!'"></i></label>
                                                    <vue-html5-editor @change="updateComment" :content="content" :height="200"></vue-html5-editor>
                                                </div>
                                                <button type="submit" class="btn btn-success">Add Comment</button>
                                            </form>
                                        </div>
                                    </div>
                                    <div class="panel" v-if="selectedTab==='resources'">
                                        <div class="panel-heading">
                                            <h2>Course Resources</h2>
                                        </div>
                                        <div class="panel-body resources">
                                            <div v-if="instance.video.resources">
                                                <div class="resource-table">
                                                    <ul>
                                                        <li v-for="(resource, index) in instance.video.resources">
                                                            <a :href="resource.url" target="_blank">{{resource.name}}</a>
                                                            <p>{{resource.description}}</p>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <file-list :instanceId="instance.id"></file-list>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="panel annotation" v-if="selectedTab==='transcript'">
                                        <div class="panel-heading">
                                            <h2>Annotations &#38; Flyouts</h2>
                                        </div>
                                        <div class="panel-body" v-if="selectedChapter">
                                            <table class="annotations">
                                                <thead>
                                                    <tr>
                                                        <th>Timecode</th>
                                                        <th>Annotation</th>
                                                        <th>Edit</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="annotation in selectedChapter.annotations">
                                                        <td>{{annotation.time | timecode}}</td>
                                                        <td>{{annotation.text}}</td>
                                                        <td>
                                                            <i @click="editAnnotation(annotation.id)" class="fa fa-pencil"></i>
                                                            <i @click="deleteAnnotation(annotation.id)" class="fa fa-trash-o"></i>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div v-else>Please select a chapter</div>
                                    </div>
                                    <div class="panel" v-if="selectedTab==='transcript'">
                                        <div class="panel-heading transcript-heading">
                                            <h2>Transcript Editor 
                                                <i @click.prevent="editingTranscript = !editingTranscript" 
                                                    class="fa cursor-pointer" 
                                                    :class="{
                                                        'fa-edit': !editingTranscript,
                                                        'fa-close': editingTranscript

                                                    }"></i>
                                            </h2>
                                        </div>
                                        <div class="panel-body" v-if="selectedChapter">
                                            <p>You can review the select chapter's video transcript below.</p>
                                            <p>They sometimes take up to an hour to generate but will appear once ready!</p>
                                            <p>You can edit them directly below and save your changes if they need improving.</p>
                                            <div class="transcript nice-scrollbar" v-if="selectedChapter && selectedChapter.transcript">
                                                <div class="text well" ref="text">
                                                    <span 
                                                        @keyup="updateText($event, index)" 
                                                        @click="jumpToTime(phrase)"
                                                        :contenteditable="editingTranscript" 
                                                        :class="{ 
                                                            'cursor-pointer':!editingTranscript,
                                                            'highlighted': currentTime >= phrase.start && currentTime <= phrase.end                                                        
                                                        }"
                                                        v-for="(phrase,index) in selectedChapter.transcript.text">
                                                        {{phrase.text | nobreak}} 
                                                    </span>
                                                </div>                                                
                                            </div>
                                            <div class="form-group" v-if="editingTranscript">
                                                <button @click.prevent="updateTranscript" class="btn btn-primary">Save Transcript Edits</button>
                                            </div>
                                            <button v-if="selectedChapter" @click.prevent="regenerateTranscript()" class="btn btn-default">Regenerate Transcript</button>
                                        </div>
                                    </div>
                                </div>
                                <div class="panel col-xs-12 col-md-4">
                                    <div class="panel-heading">
                                        <h2>Chapters</h2>
                                    </div>
                                    <div class="panel-body chapters">
                                        <ul>
                                            <li v-for="(chapter, index) in instance.video.video_chapters" class="row video-chapter">
                                                <div class="col-xs-12 chapter-heading form-group" v-if="chapter.heading">
                                                    <input type="text" v-model="chapter.heading" class="form-control" readonly />
                                                </div>
                                                <div class="col-xs-12">
                                                    <input @click="selectChapter(chapter)" class="form-control" v-model="chapter.title" type="text" readonly />
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="panel-heading">
                                        <h2>Weekly Summary</h2>
                                    </div>
                                    <div class="panel-body summary">
                                        <div>
                                            <div v-html="instance.video.summary"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import videos from '../../services/videos';
import courses from '../../services/courses';
import terms from '../../services/terms';
import paths from '../../services/paths';

import S3Utils from '../../packages/s3-utils';
import toastr from 'toastr';
import PolyVideo from './../reusable/poly-video';
import fileList from './../reusable/files/Files.vue';


import moment from 'moment';
import _ from 'lodash';

export default {
    props: ['courses'],
    data() {
        return {
            supervisorTerms: null,
            userPath: null,
            allPaths: null,
            currentTerms: [],
            currentWeek: null,
            videoPlayerUrl: null,
            selectedChapter: null,
            currentTime: null,
            selectedTerm: null,
            selectedInstance: null,
            editingTranscript: false,
            selectedTab: 'description',
            annotation: {
                text: '',
                hotKeys: [],
                time: null,
                position: 'left'
            },
            comments: [],
            newComment: null,
            commentReply: {},
            showReplyForm: null,
            transcriptChanges: [],
            videoPlayerVjsOptions: {
                fluid: true,
                playbackRates: [0.7, 1.0, 1.25, 1.5, 2.0, 3.0],
                plugins: {
                    framebyframe: {
                        fps: 23.98,
                        steps: [
                            { icon: 'fa-undo', step: -10 },
                            // { icon: 'fa-step-backward', step: -1 },
                            // { icon: 'fa-step-forward', step: 1 },
                            { icon: 'fa-repeat', step: 10 },
                        ]
                    },
                },
            },
        }
    },
    components: {
        PolyVideo,
        fileList
    },
    created() {

    },
    async mounted() {

        this.currentWeek = 1;

        let supervisorTerms = await terms.getSupervisorTerms(this);

        const now = new Date();

        let pathData = await paths.getPaths(false);

        this.allPaths = pathData;
        
        let userPath;

        if (localStorage.path && localStorage.path !== 'null') {
            userPath = parseInt(localStorage.path);
            this.userPath = pathData.find(p => p.id == userPath);
        } else {
            this.userPath = {id:99, courses:[]}
        }

        // get all terms that end in the future
        let filteredTerms = supervisorTerms.data.terms.filter(t => new Date(t.endDate) > now).reverse();

        this.supervisorTerms = filteredTerms;

        if (this.supervisorTerms.length) {
            const currentWeek = moment().diff(this.supervisorTerms[0].startDate, 'weeks');
            if (currentWeek < 1) {
                this.currentWeek = 1;
            } else {
                currentWeek <= 16 ? this.currentWeek = currentWeek : this.currentWeek = 16;
            }
        }
        


        this.getContent();
        
    },
    methods: {
        jumpToTime(phrase) {
            this.$refs.videoPlayer[0].getVjsPlayer().currentTime(phrase.start);
        },

        async getContent() {
            
            this.$store.dispatch('toggle',{type:'loading', boolean: true});
            
            this.$set(this.currentTerms, []);           

            const currentTerms = _.cloneDeep(this.supervisorTerms);    

            const houdiniPath = this.allPaths.find(p => p.id == 9200);

            const hasHoudiniPath = this.userPath.id == 9200;

            for (const term of currentTerms) {          

                if (term.type === 'mentorship') {

                    if (localStorage.hasAllStudentPaths && localStorage.hasAllStudentPaths == 'true') {
                        // show all courses
                    }
                    else {
                        if (hasHoudiniPath) {
                            term.instances = term.instances.filter((i)=>{                                                         
                                return houdiniPath.courses.includes(i.associated.id)                            
                            });
                        } else {
                            term.instances = term.instances.filter((i)=>{                                                                      
                                return !houdiniPath.courses.includes(i.associated.id)
                            });    
                        }
                    }
                    
                }
                else if (term.type !== 'foundation' || (term.type === 'foundation' && hasHoudiniPath)) {                                        
                    term.instances = term.instances.filter((i)=>{             
                        return this.userPath.courses.includes(i.associated.id)                        
                    });
                }
                else if (term.type === 'foundation' && !hasHoudiniPath) {
                    const courseIds = this.courses.map(c => c.id)
                    const instanceIds = term.instances.map(i => i.id)
                    term.instances = term.instances.filter((i)=>{             
                        return courseIds.includes(i.id)
                    });                    
                }
                
                for (const instance of term.instances) {
                    try {
                        const vid = await videos.getByWeek(this, instance.id, this.currentWeek);
                        instance.video = vid.data;                        
                    } catch (e) {
                        // no videos for this instance/week
                    }
                }
                term.instances = term.instances.filter(i => i.video)
            }
            
            this.currentTerms = _.cloneDeep(currentTerms);


            this.$store.dispatch('toggle',{type:'loading', boolean: false});
        },
        isInPath(courseId) {
            return this.path.courses.includes(courseId);
        },
        getComments() {
            this.comments = null;
            if (!this.selectedChapter) { return; }

            videos.getComments(this, this.selectedChapter.id).then((response) => {

                if (!this.$refs.videoPlayer || this.$refs.videoPlayer.length === 0) { return; }

                var video = this.$refs.videoPlayer[0].getVjsPlayer();


                if (_.isFunction(video.markers.removeAll)) video.markers.removeAll();

                var topLevel = [];

                var comments = response.data;

                comments.forEach(function(c, i) {
                    if (c.parentId === null) {
                        comments.splice(i, 1);
                        comments.unshift(c)
                    }
                })

                comments = comments.sort(function(a, b) {
                    return a.parentId - b.parentId;
                });

                if (comments && comments.length > 0) {
                    comments.forEach(function(comment) {
                        if (!comment.parentId) {
                            comment.children = []
                            topLevel.push(comment);
                        } else {
                            var index = topLevel.findIndex(function(x) { return x.id === comment.parentId });
                            topLevel[index].children.push(comment);
                        }
                    });

                }

                window.setTimeout(() => {
                    this.comments = topLevel;
                    this.$refs.videoPlayer[0].getVjsPlayer().markers.add(topLevel);
                }, 1000)
            });

        },
        updateComment(content) {
            this.newComment = content;
        },

        updateCommentReply(content, id) {
            this.commentReply[id] = content;
        },
        addComment(instance, parentId, commenter) {
            var self = this;

            if (!self.$refs.videoPlayer) {
                toastr.error('Please start the video before commenting on it');
                return false;
            }
            var timestamp = self.$refs.videoPlayer[0].getVjsPlayer().currentTime();


            var comment = {
                timestamp: timestamp,
                userId: localStorage.account_id,
                chapterId: self.selectedChapter.id,
                videoId: instance.video.id,
                courseTitle: instance.associated.name,
                videoTitle: instance.video.title,
                chapterTitle: self.selectedChapter.title,
                instanceId: instance.id,
                courseId: instance.associated.courseId,
                week: self.currentWeek
            }

            if (parentId) {
                comment.parentId = parentId;
                comment.text = self.commentReply[parentId];
                comment.commenter = commenter.id;
            } else {
                comment.text = self.newComment
            }


            videos.addComment(self, comment).then(function(response) {
                if (response.data.id) {
                    toastr.success('Comment added');
                    self.newComment = null;
                    self.commentReply = {};
                    self.getComments();
                } else {
                    toastr.error('Error adding comment');
                }

            });

        },
        jumpToTimecode(e) {

            if (e.keyCode == 8 || e.keyCode == 46) return; // deleting

            var self = this;
            let timecode = this.$refs.timecode.value;

            var player = self.$refs.videoPlayer[0].getVjsPlayer();
            try {
                var a = timecode.split(':');
                var seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);
                self.currentTime = seconds;
                player.currentTime(seconds)
            } catch (e) {
                toastr.error('Invalid timecode');
            }
        },
        downloadFile(file, type, id, source) {
            this.$store.dispatch('populate', {
                type: 'downloading',
                data: true
            });
            this.$bus.$emit('download', file, type, id, source);

        },
        getMarkers(player) {
            player.markers({
                markers: [],
                onMarkerReached: function(event) {
                    self.selectedComment = event;
                }
            });
        },
        getAnnotations(player) {
            var self = this;
            var annotations = [];

            self.selectedChapter.annotations.forEach(function(annotation) {

                var content = '<p class="annotation">' + annotation.text;
                // content +='<i class="fa fa-ban" data-id="' + annotation.id + '"></i>';
                // content += '<i class="fa fa-edit" data-id="' + annotation.id + '"></i></p>';

                content += '<div class="buttons">';

                if (annotation.controlKeys) {
                    annotation.controlKeys.forEach(function(key) {
                        content += '<span class="control controlkey ' + key + '">' + key + '</span>';
                    });
                }

                if (annotation.hotKeys) {
                    content += '<span class="control controlkey ' + annotation.hotKeys + '">' + annotation.hotKeys + '</span>';
                }

                if (annotation.mouseButtons) {
                    annotation.mouseButtons.forEach(function(button) {
                        content += '<span class="control mousebutton ' + button + '"></span>';
                    })
                }

                content += '</div>';

                annotations.push({
                    content: content,
                    start: annotation.time,
                    end: annotation.time + 5,
                    align: 'bottom-' + annotation.position
                });

            });

            player.overlay({
                overlays: annotations
            });
        },
        selectChapter(chapter, loadWithoutPlaying) {

            this.videoPlayerUrl = S3Utils.buildS3Url(
                'ttto-course-videos-raw',
                `${chapter.url}.mp4`,
            );
            this.selectedChapter = chapter;

            if (!loadWithoutPlaying) {
                this.$nextTick(()=>{
                   this.$refs.videoPlayer[0].getVjsPlayer().play();
                });
            }
            

        },
        requires(video, type) {
            return video.doesNotRequire.indexOf(type) === -1;
        },
        onPlayerTimeupdate(player) {
            this.currentTime = player.currentTime();
        },
    },
    watch: {
        'selectedInstance': function() {
            var self = this;
            self.getComments();
            const term = this.currentTerms.find(t => t.id === self.selectedTerm);
            const instance = term.instances.find(i => i.id === self.selectedInstance);
            if (instance && instance.video && instance.video.video_chapters && instance.video.video_chapters.length > 0){
                this.selectChapter(instance.video.video_chapters[0], true);                
            }
            
        },
        'selectedChapter': function() {
            var self = this;
            self.getComments();
        },
        'selectedTerm': function() {
            var self = this;
            self.getComments();
        },
    },
    computed: {

    }
}

</script>
<style lang="scss" scoped>
.instance-name {
    border-bottom: 1px solid #777;
    padding-bottom: 1rem;
    
    img {
        position:relative;
        top:-4px;
    }
}

.terms {
    padding: 1rem;
    .instance-name {
        cursor: pointer;
    }
}

.video-chapter {
    margin-bottom: 1rem;

    input {
        cursor: pointer !important;
    }
}

.sku {
    display: block;
    clear: both;
    margin-bottom: 1rem;
    font-size: 1.8rem;
}

.buttons {
    margin-top: 2rem;
}

.summary {
    textarea {
        height: 220px !important;
    }
}

table.assignment-files {
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;

    button {
        padding: 4px 8px;
        border: none;
    }

}

.buttons {
    margin-top: 2rem;
}

.chapters .buttons {
    margin-top: 0;
}

input.timecode {
    display: inline;
    width: auto;
}

table.annotations {
    width: 100%;
    border: none;
    background: rgba(0, 0, 0, 0.2) !important;
    margin-top: 2rem;

    tbody,
    tr,
    td {
        border: none !important;
    }

    th,
    td {
        padding: 1rem;
    }

}

.checkbox-wrapper {
    padding: 5px 10px;
}

.resources.panel-body,
.chapters.panel-body {
    padding: 0 !important;
}

.resources {

    form,
    p {
        padding: 1rem;
    }
}

.resource-table {
    // padding: 0;
    background: #363636;
    // white-space: nowrap;
    // text-align: center;
    // overflow: hidden;
    // text-overflow: ellipses;

    p {
        margin: 0;
        padding: 0;
    }

    a {
        margin: 0;
    }

    i {
        cursor: pointer;
    }

    .buttons {
        margin: 10px 0;

    }

    li {
        margin-bottom: 1rem;
        padding-bottom: 1rem;
        border-bottom: 1px solid rgba(100, 100, 100, 0.5);
    }

    button {
        padding: 0 5px 2px 5px;
    }

    // tr {
    //     background: #363636;
    // }
}

.video-player-wrapper {
    margin-bottom: 2rem;
    padding: 0;

    &>.panel-body {
        padding: 0 !important;
    }

    &>.panel {
        margin-top: 2rem;
    }

}


.video-player-placeholder {
    width: 100%;
}

.comments {
    &>li {
        margin-bottom: 2rem;
    }

    margin:1rem auto 2rem;

    .author {
        margin: 0;
    }

    .author,
    .author span {
        font-size: 1.2rem;
    }

    li {
        margin-bottom: 2rem;
        //border-bottom:solid 1px #666;
    }
}

.replies {
    padding-left: 2rem;
    margin-top: 1rem;
}

.form-control:not([type="file"]) {
    background: rgba(0, 0, 0, .2) !important;
}


.panel-body {

    padding: 1rem 2rem !important;
}


label[for="lmb"] {
    background: url('../../assets/img/lmb.png');
}

label[for="cmb"] {
    background: url('../../assets/img/cmb.png');
}

label[for="rmb"] {
    background: url('../../assets/img/rmb.png');
}
.transcript {
    max-height:500px;
    overflow-y: scroll;
    margin-bottom:2rem;
}

.transcript-heading h2 {
    display:flex;
    align-items: center;
    justify-content:space-between;
}
label.mouse {
    width: 30px;
    height: 42px;
    background-size: 100% 100%;
    background-position: -1px;
    position: relative;
    top: 2rem;
}

.annotations .buttons {
    padding: 2rem 0;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-around;
    align-content: center;
    align-items: center;
    padding-bottom: 2rem;
}
.highlighted {
    background: transparentize(darken(#42b983, 15%), .5);
    color: darken(#fafafa,15%);
    font-weight: 400;
}


</style>



// WEBPACK FOOTER //
// SupervisorWeeklyContent.vue?0bd106eb